import * as React from "react";
import ModalPopup from "./commons/components/modal/ModalPopup";

export interface SettingsCannotReactivateAccountFormProps {
  cancel: () => void;
}

export default class SettingsCannotReactivateAccountForm extends React.Component<SettingsCannotReactivateAccountFormProps> {
  render() {
    return (
      <ModalPopup closeModal={this.props.cancel} class="confirmation-dialog" hideCloseIcon={false}>
        <div className="title">
          {i18n["Page.Settings.Account.Subscription.Reactivate.Modal.Title"]}
        </div>
        <div className="content">
          <div className="reactivation-description">
            {i18n["Page.Settings.Account.Subscription.CannotReactivate.Modal.Content"]}
          </div>
        </div>
      </ModalPopup>
    );
  }
}
